import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './index.module.scss';
import React from 'react';
import clsx from 'clsx';
export const ProgressLine = ({ label, count, current, warning = false, segments, currentSegment }) => {
    return (_jsxs("div", Object.assign({ className: styles.progress }, { children: [_jsx("div", Object.assign({ className: styles.progressBar }, { children: [...Array(segments)].map((_, index) => {
                    let fillPercent = 0;
                    if (currentSegment === index) {
                        fillPercent = (current / count) * 100;
                    }
                    else if (currentSegment > index) {
                        fillPercent = 100;
                    }
                    return (_jsx("div", Object.assign({ className: clsx(styles.segment, { [styles.currentSegment]: currentSegment === index }) }, { children: _jsx("div", { className: clsx(styles.fill, { [styles.fillRed]: currentSegment === index && warning }), style: { width: `${fillPercent}%` } }) }), index));
                }) })), _jsx("div", Object.assign({ className: styles.stepName }, { children: label }))] })));
};
